import { Reducer } from 'redux'
import { 
  PromptRegisterPendingReviewAction, 
  ReportRegisterFailureAction, 
  UserRegisterLoadingAction, 
  USER_REGISTER_FAILURE, 
  USER_REGISTER_LOADING, 
  USER_REGISTER_PENDING_REVIEW 
} from '@/actions/register'

type ActionTypes =
  | UserRegisterLoadingAction
  | PromptRegisterPendingReviewAction
  | ReportRegisterFailureAction

export interface State {
  email?: string;
  resultText?: string;
  success?: boolean;
  domainExists?: boolean;
  processing: boolean;
}

const initialState = { processing: false }

export const registerReducer: Reducer<State, ActionTypes> = (
  previousState = initialState,
  action
) => {
  switch (action.type) {
    case USER_REGISTER_LOADING: 
      return ({ email: action.payload.email, processing: true });
    case USER_REGISTER_FAILURE: 
      return { 
        ...previousState,
        resultText: action.payload.errMsg,
        success: false,
        processing: false,
        domainExists: action.payload.domainExists 
      };
    case USER_REGISTER_PENDING_REVIEW:
      return { ...previousState, success: true, processing: false };
    default:
      return previousState;
  }
}

export const getRegisterState = (state:any) => state.od.register;
